import { Atom, useAtom } from 'jotai'
import { MutableRefObject, useEffect, useRef } from 'react'

function useAtomWithRef<T>(atom: Atom<T>): [MutableRefObject<T>, T, (update?: T) => void] {
  const [value, setValue] = useAtom(atom)
  const ref = useRef<T>(value)

  useEffect(() => {
    ref.current = value
  }, [value])

  return [ref, value, setValue]
}

export default useAtomWithRef
